export default __webpack_public_path__ + "static/media/engine.c37c3c84.png";